import React from 'react';

import { Group, Spacing, Text } from '@vkontakte/vkui';

import { Banner } from './components/Banner';
import { Description } from './components/Description';
import { FamousPersons } from './components/FamousPersons';
import { FeedbackForm } from './components/FeedBackForm';
import { Result } from './components/Result';
import styles from './index.module.css';
import { ContentResultPageProps } from './types';
import { SITE_URL } from '../../../../../components/Footer/Footer';

export const DesktopResultContent: React.FC<ContentResultPageProps> = ({
  temperamentData,
  hasUserAgreed,
  shareResult,
  onAppWithTestsClick,
  onRadioChange,
  title,
}) => {
  return (
    <Group className={styles.container} separator='hide'>
      <Spacing size={32} />
      <Result title={title} temperamentData={temperamentData}/>
      <Spacing size={32}/>
      <div className={styles.content}>
        <Description temperamentData={temperamentData}/>
        <Spacing size={32} />
        <FamousPersons temperamentData={temperamentData}/>
        <FeedbackForm
          hasUserAgreed={hasUserAgreed} 
          onRadioChange={onRadioChange}
          shareResult={shareResult}/>         
        <Spacing size={16} />
        <Banner onAppWithTestsClick={onAppWithTestsClick}/>
        <Text className={styles.text}>
          Разработано учеными из{' '}
          <a
            href={SITE_URL}
            target="_blank"
            className={styles.link}
            style={{ marginBottom: 32 }} rel="noreferrer"
          >
            лаборатории прикладного искусственного интеллекта СПб ФИЦ РАН
          </a>
        </Text>
        <Spacing size={32}/>
      </div>
    </Group>
  );
};
